import {UserCourseLivePage} from "@/models/live/userCourseLivePage";
import {CourseLivePlan} from "@/models/live/courseLivePlan";
import https from "@/utils/https";
import {Root} from "@/models/root";
import {Method} from "axios-mapper";

export interface CourseLiveVO {
  live: CourseLivePlan;
  recordedPages: UserCourseLivePage[];
  previewMaterialsPages: UserCourseLivePage[];
  instructorCoursewarePages: UserCourseLivePage[];
  extendedReadingPages: UserCourseLivePage[];
}

/**
 * 获取直播内容
 * @param courseId
 * @param partId
 */
export const fetchLiveContent = (courseId: number, partId: number): Promise<Root<CourseLiveVO> | null> => {
  return https(true).request<Root<CourseLiveVO>>(`/course/user/live/${courseId}/${partId}/liveContent`, Method.GET)
}

/**
 * 获取直播间地址
 * @param livePlanId
 */
export const fetchLiveUrl = (livePlanId: number): Promise<Root<{ url: string }> | null> => {
  return https(true).request<Root<{ url: string }>>(`/course/livePlan/getLiveurl`, Method.GET, {
    liveId: livePlanId
  })
}

/**
 * 提交点击次数
 * @param pageId
 */
export const fetchCommitLivePageUseTime = (pageId: number): Promise<Root<boolean> | null> => {
  return https(true).request<Root<boolean>>(`/course/user/live/${pageId}/commitLivePageUseTime`, Method.PUT)
}
